var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar1 = function SvgDefaultAvatar1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_1_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_1_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 55.3c5.2 0 7.5-.4 7.5-1.6 0-.9-1-1.2-4-1.3-.8-.2-.9-1.5-.9-4.5V31.6c0-2.9.1-3.8.6-4.1.8-.4 1.1-.8 1.1-1.3 0-.8-.7-1.1-1.7-1.1-1.4 0-3.6.4-5.6 1.1-3 1-5.6 2.4-5.6 3.5 0 .5.4.9 1.1.9.9 0 3.1-.9 4.4-1.1.6.2.8 1.6.8 3.1v15.2c0 3-.1 4.3-.9 4.5-3.1.1-4 .4-4 1.3-.3 1.2 2.1 1.7 7.2 1.7z"
  })));
};
export default SvgDefaultAvatar1;